import React, { useEffect, useState } from "react";
import { MainContainer } from "./styles";
import { userService } from "../../../../services/modules/user";
import { notification, Space, Table, TableProps, Tag } from "antd";
import { DataType } from "./types";

const UserContent: React.FC = (): JSX.Element => {
  const [users, setUsers] = useState<DataType[]>();

  const fetchUsers = () => {
    userService.getUsers().then((response) => {
      const mapped = response.map(
        (user) =>
          ({
            key: user._id,
            name: user.name,
            email: user.email,
            permission: user.permission,
          } as DataType)
      );

      setUsers(mapped);
    });
  };

  const definePermissionColor = (permission: string) => {
    switch (permission) {
      case "master":
        return "gold";
      case "user":
        return "blue";
      case "trial":
        return "magenta";

      default:
        return "geekblue";
    }
  };

  const updatePermission = (permission: string, id: string) => {
    userService.updatePermission(id, permission).then(() => {
      notification.success({
        message: "Sucesso!",
        description: "Permissão atualizada com sucesso!",
      });

      fetchUsers();
    });
  };

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      filterSearch: true,
      onFilter: (value, record) => record.email.startsWith(value as string),
    },
    {
      title: "Permissão",
      key: "permission",
      dataIndex: "permission",
      render: (_, { permission }) => (
        <Tag color={definePermissionColor(permission)}>
          {permission.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {record.permission === "trial" && (
            <a onClick={() => updatePermission("user", record.key)}>
              Dar acesso
            </a>
          )}
          {record.permission !== "master" && (
            <a onClick={() => updatePermission("master", record.key)}>
              Tornar Admin
            </a>
          )}
        </Space>
      ),
    },
  ];

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <MainContainer>
      <Table dataSource={users || []} columns={columns} loading={!users} />
    </MainContainer>
  );
};

export default UserContent;
